module.exports = __webpack_public_path__ + "static/media/backjs.ec78f7b2.jpg";